import { render, staticRenderFns } from "./registro.vue?vue&type=template&id=962cbe22&"
import script from "./registro.vue?vue&type=script&lang=js&"
export * from "./registro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RegisterForm: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/forms/RegisterForm.vue').default})
